let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d6I04")).then(() => parcelRequire('77kYr'));